import { Button, HStack, Icon, Text } from '@betterment/samba-react';

const InlineErrorFallback = ({ resetError }: { resetError: () => void }) => (
  <HStack css={{ gap: 'space.100' }}>
    <Icon size="small" name="ExclamationCircle" />
    <Text>
      Something went wrong.{' '}
      <Button variant="textPrimary" onClick={resetError}>
        Try again
      </Button>
    </Text>
  </HStack>
);

export default InlineErrorFallback;
